import { createAuthClient } from 'better-auth/react';
import { twoFactorClient } from 'better-auth/client/plugins';

// The login page handles the code step itself (no redirect).
export const authClient = createAuthClient({ basePath: '/api/auth', plugins: [twoFactorClient()] });

export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    message: string,
    public details?: Record<string, unknown>,
  ) {
    super(message);
  }
}

/** Calls our API (same origin, session cookie) and throws ApiError with a readable message. */
export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await fetch(`/api/v1${path}`, {
    ...init,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...init.headers },
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => null)) as { error?: { code: string; message: string; details?: Record<string, unknown> } } | null;
    throw new ApiError(res.status, body?.error?.code ?? 'error', body?.error?.message ?? 'Er ging iets mis.', body?.error?.details);
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}

export type Me = {
  user: { id: string; name: string; email: string; emailVerified: boolean; twoFactorEnabled: boolean };
  salons: Array<{ orgId: string; name: string; slug: string; role: 'owner' | 'manager' | 'staff'; support: boolean; status: string; twoFactorRequired: boolean }>;
  isAdmin: boolean;
};

export type Salon = {
  salon: {
    id: string;
    name: string;
    slug: string;
    businessType: string;
    status: string;
    trialEndsAt: string | null;
    onboardingStep: number;
  };
  role: 'owner' | 'manager' | 'staff';
  staffMemberId: string | null;
  /** Set while our support team is looking in (time-limited). */
  supportUntil: string | null;
};
